// extracted by mini-css-extract-plugin
export var checked = "header-landing-page-module--checked--17b91";
export var header = "header-landing-page-module--header--303e7";
export var headerLoghiLandingPage = "header-landing-page-module--header-LoghiLandingPage--542b0";
export var headerLoghiLandingPageContainer = "header-landing-page-module--header-LoghiLandingPageContainer--57c6c";
export var headerLoghiLandingPageImage = "header-landing-page-module--header-LoghiLandingPageImage--9d536";
export var headerLogoLandingPage = "header-landing-page-module--header-LogoLandingPage--1bfbb";
export var headerTextLandingPage = "header-landing-page-module--header-TextLandingPage--97a8b";
export var unchecked = "header-landing-page-module--unchecked--26d0e";